export enum LegalChangesSection {
  major = 'MAJOR',
  minor = 'MINOR',
  new = 'NEW',
  notRelevant = 'NOT_RELEVANT'
}
